import React from "react";

import Text from "src/components/text";
import { SearchQueryItem } from "src/types/reports";

import styles from "./searchQueryCard.module.scss";


export interface SearchQueryCardProps {
  item: SearchQueryItem;
}

export const SearchQueryCard: React.FC<SearchQueryCardProps> = ({ item }) => {
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={styles.queryItem}>
          <div className={styles.queryNumber}>{item.manualIndex}</div>
          <div className={styles.data}>
            <Text lines={1} className={styles.title} text={item.query || ""} />
            <div className={styles.metrics}>
              <span>{item.totalCount || 0} Searches</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
